import React from 'react'
import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import { CircularAvatar } from '../../commons';

type AppProps={
    tableHeaders: TableHeadersType[] | [];
    data: any [] | [];

}
const UsersWorkingOnSpecificJobTable = ({data ,tableHeaders }:AppProps) => {
  return (
    <>
  
    {data?.length > 0 &&
        data?.map((specificJobData: any) => {
          return (
            <tr className="text-left" >
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "userName") {
                    return (
                      <td className="text-left">
                        {/* {specificJobData?.userName} */}
                        <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <CircularAvatar
                          name={!!specificJobData?.userName ? specificJobData?.userName : !!specificJobData?.user_name ? specificJobData?.user_name : "" }
                          image={
                            specificJobData?.profile_pic &&
                            specificJobData?.profile_pic?.file_url
                          }
                        />
                        <div style={{display:"flex", flexDirection:"column"}}>
                          <span>{!!specificJobData?.userName ? specificJobData?.userName : !!specificJobData?.user_name ? specificJobData?.user_name : "" }</span>
                          <span style={{color:"#6e7491", fontSize:"12px"}}>{specificJobData?.jobTitle}</span>

                          {/* {`${userData?.first_name} ${userData?.last_name} `} */}
                        </div>
                      </div>
                      </td>
                    );
                  } else if (header?.value == "department") {
                    return (
                      <td className="text-left">
                        {specificJobData?.department?specificJobData?.department:"--/--"}
                      </td>
                    );
                  } 
                  else if (header?.value == "total_work_hours") {
                    return (
                      <td className="text-left">
                        {specificJobData?.total_work_hours ? +specificJobData?.total_work_hours?.toFixed(2) : 0}
                      </td>
                    );
                  }
                  else if (header?.value == "scheduled_hours") {
                    return (
                      <td className="text-left">
                        {specificJobData?.total_hours ? +specificJobData?.total_hours?.toFixed(2) : 0 }
                      </td>
                    );
                  }  
                  return null;
                })}
            </tr>
          );
        })}
      
      </>
  )
}

export default UsersWorkingOnSpecificJobTable
